export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '18px 20px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const rowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '20px',
  flexWrap: 'wrap',
};

export const identityStyles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    flex: '1 1 260px',
    minWidth: 0,
  },
  avatar: color => ({
    flexShrink: 0,
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: color,
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '13px',
  }),
  role: {
    display: 'block',
    color: ({ palette }) => palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: '2px',
  },
};

export const fieldGroupStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '32px',
  flexWrap: 'wrap',
};

export const fieldLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const emailLineStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const emailInfoStyles = {
  display: 'inline-flex',
  color: ({ palette }) => palette.text.secondary,
  cursor: 'default',
};

export const fieldHelperStyles = {
  display: 'block',
  marginTop: '3px',
  color: ({ palette }) => palette.text.secondary,
};

export const deliverySelectStyles = {
  minWidth: '104px',
  '& .MuiSelect-select': {
    padding: '5px 28px 5px 10px',
    fontSize: '12px',
    fontWeight: 700,
  },
};

export const mailHintStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '9px 13px',
  borderRadius: '8px',
  border: ({ palette }) => `1px dashed ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.text.secondary,
};
